import { exportGetLoansByCriteria, getCheckoutSessionsByCriteria } from '@nemuru-eng/js-api-client';

import { ListFilter } from '@/components/modules/CheckoutSession/List/types/ListFilter';
import { ListQueryProps } from '@/types/ListQueryProps';
import { exportXLSX } from '@/utils/exportXLSX';
import { fetchForDataGrid } from '@/utils/fetchForDataGrid';

export function useFetchCheckoutSessionList({ additionalFilters }: { additionalFilters?: ListFilter[] }) {
  const queryAdditionalFilters = additionalFilters ?? [];
  const baseQueryFilters = [
    // {
    //   field: 'asset_type',
    //   operator: 'in',
    //   value: ApplicationTypeMap.toAssetTypes(applicationType),
    // },
    ...queryAdditionalFilters,
  ];

  const fetchList = async (query: ListQueryProps) => {
    const customFilters: ListFilter[] = baseQueryFilters.concat(query?.filters);
    const dataTransform = (result) => ({ ...result, data: result.data });
    return fetchForDataGrid(getCheckoutSessionsByCriteria, { ...query, filters: customFilters }, dataTransform);
  };

  const fetchXLSXExport = (query: ListQueryProps) => {
    const customFilters: ListFilter[] = baseQueryFilters.concat(query?.filters);
    return exportXLSX(exportGetLoansByCriteria, { ...query, filters: customFilters });
  };

  return { fetchList, fetchXLSXExport };
}
